/* Core */
import { Carousel, Carousel_CoreInit, AjaxifyGrid_CoreInit, Accordion, Tabs, Popup, Form, Form_CoreInit, Burger, Mobile, Scrollbar, Header_CoreInit, TRANSITION_END, formatDate, iOS, Android } from './core'
import Header from './modules/header'
import Calendar from './modules/calendar'
import Swiper, { EffectFade } from 'swiper'
import Hero from './plugins/hero'
import Vh from './modules/vh'

Carousel_CoreInit([
	{
		classSelector: 'carousel--style--actualites',
		swiperOptions: {},
	},
	{
		classSelector: 'carousel--style--evenements',
		swiperOptions: {},
	},
	{
		classSelector: 'carousel--style--hero',
		swiperOptions: Hero,
	},
	{
		classSelector: 'carousel--style--services',
		swiperOptions: {},
	},
])

Form_CoreInit([
	{
		classSelector: 'builder-form--contact',
		formOptions: {
      floating_labels: true,
      auto_scroll: true,
      auto_scroll_offset: function() {
        let offset = $('.header').outerHeight('false')
        if ($('.top-bar').length && $('.top-bar').is(':visible')) {
          offset += $('.top-bar').outerHeight(false)
        }
        offset += $.mlmi.mobile.isMobile ? 40 : 80
        return offset
      },
      onInit: function(form) {
        $(form).find('.select__options > ul > li:first-child').addClass('disabled')
      },
    },
	},
  {
		classSelector: 'builder-form--long',
		formOptions: {
			floating_labels: false,
      auto_scroll: true,
      auto_scroll_offset: function() {
        let offset = $('.header').outerHeight('false')
        if ($('.top-bar').length && $('.top-bar').is(':visible')) {
          offset += $('.top-bar').outerHeight(false)
        }
        offset += $.mlmi.mobile.isMobile ? 120 : 140
        return offset
      },
      date_picker: {
        dateFormat: 'dd/mm/yy',
        changeMonth: function() {
          return $('.builder-form').hasClass('builder-form--remb-arbre')
        }(),
        changeYear: function() { 
          return $('.builder-form').hasClass('builder-form--remb-arbre')
        }(),
        monthNamesShort: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        yearRange: '2005:2024',
      },
      onBeforeSubmit: function(form) {
        let fileField = form.find('.field--type-file')
        if (fileField.length) {
          let fileSize = Math.floor(window.totalSize / 1024 / 1024)
          if (fileSize > 15) {
            form.get_object().options.auto_scroll = false
            let errors = {
              success: false,
              error: '<p class="form-error">Veuillez réviser les champs du formulaire.</p>',
              errors: {},
            }
            errors.errors[fileField.find('input[type="file"]').attr('name')] = '<p class="field-error">Le poids total excède 15 Mo.</p>'
            form.handle_error(errors)
            form.get_object().options.auto_scroll = true
            return 'prevent'
          }
        }
        return true
      },
		},
	},
])

Header_CoreInit()

AjaxifyGrid_CoreInit([
	{
		classSelector: 'grid--postitem__location',
    afterInit: function(grid) {
      grid.parent().css('max-height', '')
    },
		afterUpdate: function(grid) {
			Accordion.init()
      setTimeout(function() {
        grid.parent().css('max-height', '')
      }, 310)
		},
		afterReplace: function(grid) {
			Accordion.init()
      setTimeout(function() {
        grid.parent().css('max-height', '')
      }, 310)
		},
	},
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

	/* Search page field */
	$('.search-form__input').each(function() {
		$(this).SearchPageField()
	})

	/* Header */
	Header.init()

  /* Accordéons */
  Accordion.init()

  /* Vh */
  Vh.init()

  /* Accordéon autoscroll */
  $('.accordion[aria-multiselectable="false"] button').on('click', function() {
    let currentAccordion = $(this),
    previousAccordion = currentAccordion.parent('.accordion-item').prev('.accordion-item')
    if (previousAccordion.length) {
      let headerOffset = $('.header').outerHeight(false)
      if ($('.featured-message--style-top-bar').length) {
        headerOffset += $('.featured-message--style-top-bar').outerHeight(false)
      }
      let targetTop = previousAccordion.offset().top + previousAccordion.find('.accordion__header').outerHeight(false) - headerOffset
      if ($(window).scrollTop() > targetTop) {
        $('body, html').scrollTo(targetTop, 450, 5, 'easeInOutQuart')
      }
    }
  })

  /* Onglets */
  let tabs = Tabs.init({
    changeHash: false,
  })

  /* Filtrage résultats de recherche */
  if ($('body').hasClass('search-page') && 'tabsets' in tabs && tabs.tabsets.length) {
    /* Remove unused tabs */
    if (!$('#panel-tous-les-resultats .search-item--type-page').length) {
      $('#tab-pages').hide()
    }
    if (!$('#panel-tous-les-resultats .search-item--type-blog-post').length) {
      $('#tab-actualites').hide()
    }
    if (!$('#panel-tous-les-resultats .search-item--type-attachment').length) {
      $('#tab-documents').hide()
    }

    /* Switch tabs */
    let tabset = tabs.tabsets[0]
    tabset.on('tab_changed', function(e, old_tab, new_tab) {
      old_tab.already_seen = true
      if (new_tab.already_seen == undefined) {
        let results = $('#panel-tous-les-resultats .search-results').clone()
        if (new_tab.name == 'pages') {
          results.find('.search-item:not(.search-item--type-page)').remove()
        } else if (new_tab.name == 'actualites') {
          results.find('.search-item:not(.search-item--type-blog-post)').remove()
        } else if (new_tab.name == 'documents') {
          results.find('.search-item:not(.search-item--type-attachment)').remove()
        }
        new_tab.panel.append(results)
      }
    })
  }

  /* Recherche après redirection */
  if (window.location.hash == '#recherche') {
    $('.js-search').trigger('click')
  }

  /* Popups */
  Popup.init()

	/* Calendar */
	Calendar.init()

  /* Fade-in elements */
  $('.accordion').find('.fade-in, .slide-in').removeClass('fade-in slide-in')
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

	/* Sharing */
	$('.post-share').each(function() {
		$(this).PostShare()
	})

	/* Fix content */
	$('.post-share-positioner').each(function() {
		let fixedContent = $(this).FixedContent({
			bottomBlocker: $('.blog-post__end'),
			container: $('.blog-post__share-content'),
			limitFromTop: 95,
			mobile: false,
		})
	})

	/* Copy page URL */
	$('.post-share__action--copy-link').on('click', function() {
		let self = $(this)
		self.find('textarea').val(window.location.href).focus().select()
		document.execCommand("Copy")
		self.find('span').addClass('visible').text('Lien copié !')
		self.addClass('--visible')
		setTimeout(function() {
			self.find('span').removeClass('visible')
			self.removeClass('--visible')
		}, 3200)
	})

	/* Location filters */
	$('.location-filters').each(function() {
		$(this).LocationFilters()
	})

	/* Blog Categories */
	$('.blog-filters').each(function() {
		$(this).BlogCategories()
	})

  /* Mobile form tweak */
  if ($('.builder-form--affichage').length) {
    $.mlmi.mobile.add(function() {
      $('.field-container--date_affichage_debut .field-instruction').appendTo($('.field-container--date_affichage_fin'))
    }, function() {
      $('.field-container--date_affichage_fin .field-instruction').appendTo($('.field-container--date_affichage_debut'))
    })
  }

  /* Ajax grid */
  if ($('.ajax-load-more__wrapper').length) {
    $(window).on('resize orientationchange load', function() {
      $('.ajax-load-more__wrapper').css('max-height', '')
    })
  }

	if (window.location.hash && $(window.location.hash + '-container').length > 0) {
		$(window.location.hash + '-container').find('.js-accordion__header').click();
		var targetTop = $(window.location.hash).offset().top;
		$('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
	}
})
